import { t, useLanguage } from "@/i18n/LanguageContext";export default function Marquee({ items, dark = true }) {useLanguage();
  const row = [...items, ...items];
  return (
    <div
      data-testid="marquee-band"
      className={`overflow-hidden border-y py-4 ${
      dark ? "border-white/10 bg-brand-navy" : "border-slate-200 bg-white"}`
      }>
      
      <div className="marquee-track flex w-max items-center gap-10">
        {t(row.map((item, i) =>
        <span
          key={i}
          className={`flex items-center gap-10 font-mono text-xs uppercase tracking-[0.3em] ${
          dark ? "text-white/80" : "text-brand-navy"}`
          }>
          
            {t(item)}
            <span className="h-1.5 w-1.5 rounded-full bg-brand-lime" />
          </span>
        ))}
      </div>
    </div>);

}
